import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import Header from '../components/Header';
import Icon from '../components/Icon';
import UserIdCard from '../components/UserIdCard';
import { useAuth } from '../hooks/useAuth';
import { usePageTitle } from '../hooks/usePageTitle';
import { logout } from '../services/apiSLTP/auth';
import { capitalizeFirstLetter, formatName } from '../utils/capitalize';
import IconButton from '../components/shared/IconButton';
import PrimaryBox from '../components/PrimaryBox';

const ProfilePage: React.FC = () => {
    const { t } = useTranslation();
    const { user, logout: removeConnection } = useAuth();
    const navigate = useNavigate();
    usePageTitle(formatName(user?.firstName, user?.lastName));

    const handleLogout = async () => {
        await logout();
        removeConnection();
        navigate('/login');
    };

    return (
        <PrimaryBox>
            <Header
                title={t('profile')}
                breadcrumbs={[{ label: formatName(user?.firstName, user?.lastName) }]}
                subTitle={formatName(user?.firstName, user?.lastName)}
                isDateVisible={false}
            >
                <IconButton iconName="logout" title={capitalizeFirstLetter(t('logout'))} onClick={() => handleLogout()} color="error" />
            </Header>
            <div className="pad-10px">
                {user && (
                    <UserIdCard
                        firstName={user?.firstName}
                        lastName={user?.lastName}
                        id={user._id}
                        username={user.username}
                        address={user.address}
                        codeProC={user.codeProC}
                        job={user.jobId.designation}
                        profileType={user.profileId.type}
                        color={user.color}
                        arrivalDate={user.arrivalDate ? new Date(user.arrivalDate) : undefined}
                        isSpecial={user.isSpecial}
                        isSst={user.isSST}
                        phoneNumber={user.phoneNumber}
                    />
                )}
            </div>
        </PrimaryBox>
    );
};

export default ProfilePage;
